import { OnboardingVersionType } from '../states/OnboardingProvider';

export const isOnboardingVersionProperGuard = (version: number): version is OnboardingVersionType => {
  return [1, 2, 3].includes(version);
};
